// shared/common/ScenarioContext.jsx
import { createContext, useContext, useState, useCallback } from "react";

const ScenarioContext = createContext();

export function ScenarioProvider({ children }) {
  const [scenarios, setScenarios] = useState([]);
  const [activeScenarioKey, setActiveScenarioKey] = useState(null);
  const [microcycleTemplates, setMicrocycleTemplates] = useState([]);
  const [unsavedChanges, setUnsavedChanges] = useState({});
  const [autoLoadedFromDb, setAutoLoadedFromDb] = useState(false);
  const [activeMicrocycleMatchDate, setActiveMicrocycleMatchDate] = useState(null);

  const updateScenario = useCallback((key, updates) => {
    setScenarios(prev => 
      prev.map(s => s.key === key ? { ...s, ...updates } : s)
    );
  }, []);

  const updateScenarioData = useCallback((key, scenarioUpdates) => {
    setScenarios(prev => 
      prev.map(s => s.key === key 
        ? { ...s, scenario: { ...s.scenario, ...scenarioUpdates } } 
        : s
      )
    );
  }, []);

  const addScenario = useCallback((scenario) => {
    setScenarios(prev => [...prev, scenario]);
  }, []);

  const removeScenario = useCallback((key) => {
    setScenarios(prev => prev.filter(s => s.key !== key));
    setUnsavedChanges(prev => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
  }, []);

  const markUnsaved = useCallback((key, hasChanges = true) => {
    setUnsavedChanges(prev => ({ ...prev, [key]: hasChanges }));
  }, []);

  const value = {
    scenarios,
    setScenarios,
    activeScenarioKey,
    setActiveScenarioKey,
    microcycleTemplates,
    setMicrocycleTemplates,
    unsavedChanges,
    setUnsavedChanges,
    autoLoadedFromDb,
    setAutoLoadedFromDb,
    activeMicrocycleMatchDate,
    setActiveMicrocycleMatchDate,
    updateScenario,
    updateScenarioData,
    addScenario,
    removeScenario,
    markUnsaved,
  };

  return (
    <ScenarioContext.Provider value={value}>
      {children}
    </ScenarioContext.Provider>
  );
}

export const useScenarios = () => {
  const context = useContext(ScenarioContext);
  if (!context) {
    throw new Error("useScenarios must be used within a ScenarioProvider");
  }
  return context;
};
